// 셸에서 쓰는 16px 선 아이콘 — 굵기 1.6, 끝 둥글게
type P = { className?: string }
const base = (className = 'w-4 h-4') => ({
  className, viewBox: '0 0 16 16', fill: 'none', stroke: 'currentColor',
  strokeWidth: 1.6, strokeLinecap: 'round' as const, strokeLinejoin: 'round' as const, 'aria-hidden': true,
})

export const IconBoard = ({ className }: P) => (
  <svg {...base(className)}><rect x="2" y="2" width="5" height="5" rx="1" /><rect x="9" y="2" width="5" height="5" rx="1" /><rect x="2" y="9" width="5" height="5" rx="1" /><rect x="9" y="9" width="5" height="5" rx="1" /></svg>
)
export const IconClipboard = ({ className }: P) => (
  <svg {...base(className)}><rect x="3" y="2.5" width="10" height="12" rx="1.5" /><path d="M6 2.5h4v2H6zM5.5 8h5M5.5 11h3" /></svg>
)
export const IconSheet = ({ className }: P) => (
  <svg {...base(className)}><rect x="2" y="2.5" width="12" height="11" rx="1.5" /><path d="M2 6h12M6 6v7.5M2 9.5h12" /></svg>
)
export const IconKey = ({ className }: P) => (
  <svg {...base(className)}><circle cx="5.5" cy="10.5" r="3" /><path d="M7.7 8.3 13.5 2.5M11 5l1.5 1.5M12.5 3.5 14 5" /></svg>
)
export const IconBox = ({ className }: P) => (
  <svg {...base(className)}><path d="M2 5 8 2l6 3v6l-6 3-6-3z" /><path d="M2 5l6 3 6-3M8 8v6" /></svg>
)
export const IconPeople = ({ className }: P) => (
  <svg {...base(className)}><circle cx="6" cy="5.5" r="2.5" /><path d="M1.5 14c.5-2.5 2.3-4 4.5-4s4 1.5 4.5 4" /><path d="M10.5 3.2a2.5 2.5 0 0 1 0 4.6M12 10.3c1.3.5 2.2 1.8 2.5 3.7" /></svg>
)
export const IconSwitch = ({ className }: P) => (
  <svg {...base(className)}><path d="M2.5 5.5h10l-2.5-2.5M13.5 10.5h-10l2.5 2.5" /></svg>
)
export const IconExit = ({ className }: P) => (
  <svg {...base(className)}><path d="M6 2.5H3.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1H6M10.5 11 13.5 8l-3-3M13.5 8H6" /></svg>
)
// 사이드바 접기/펴기 — 왼쪽 칸이 있는 창, 화살표 방향만 다르다
export const IconRailClose = ({ className }: P) => (
  <svg {...base(className)}><rect x="2" y="2.5" width="12" height="11" rx="1.5" /><path d="M6 2.5v11M10.5 6 8.5 8l2 2" /></svg>
)
export const IconRailOpen = ({ className }: P) => (
  <svg {...base(className)}><rect x="2" y="2.5" width="12" height="11" rx="1.5" /><path d="M6 2.5v11M8.5 6l2 2-2 2" /></svg>
)
export const IconSun = ({ className }: P) => (
  <svg {...base(className)}><circle cx="8" cy="8" r="2.8" /><path d="M8 1.5v1.3M8 13.2v1.3M1.5 8h1.3M13.2 8h1.3M3.4 3.4l.9.9M11.7 11.7l.9.9M3.4 12.6l.9-.9M11.7 4.3l.9-.9" /></svg>
)
export const IconMoon = ({ className }: P) => (
  <svg {...base(className)}><path d="M13.5 9.6A5.8 5.8 0 0 1 6.4 2.5a5.8 5.8 0 1 0 7.1 7.1z" /></svg>
)
export const IconAuto = ({ className }: P) => (
  <svg {...base(className)}><circle cx="8" cy="8" r="5.8" /><path d="M8 2.2v11.6A5.8 5.8 0 0 0 8 2.2z" fill="currentColor" stroke="none" /></svg>
)
